import styled from "styled-components";
import TextAreaAutosize from "react-textarea-autosize";

import color from "../_style/color";
import withSpacing from "../hoc/withSpacing";

const Textarea = styled(TextAreaAutosize)`
  border: 1px solid ${color.gainsboro};
  width: 100%;
  resize: none;

  :focus {
    outline: none;
  }
`;

export default withSpacing(Textarea);
